<script>
  import makeChart from '../baseChartWidget'
  import chart from './chart'

  export default makeChart('hotelSpend-wdg-cmp', chart)
</script>



// WEBPACK FOOTER //
// src/components/_modules/Dashboard/widgets/HotelSpend/index.vue